import { useQuery } from '@tanstack/react-query';
import { get } from '../api/client.js';

// Single aggregated payload for /admin home. Refetches every 30s so the
// "live clocked-in" card stays fresh without a manual refresh.
export function useDashboard() {
  return useQuery({
    queryKey: ['admin', 'dashboard'],
    queryFn: () => get('/api/admin/dashboard'),
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}
